<template>
  <div
    class="catalog-action-button-component"
  >
    <span
      v-if="addButton"
      class="add-text"
    >{{ enableButtonPrefix }}</span>
    <base-button
      :dark="dark"
      :large="large"
      :text="actionText"
      :type="addButton ? 'primary' : 'secondary'"
      :icon-name="addButton ? 'cross-thin' : ''"
      :icon-variant="dark ? 'white' : '001c74'"
      :rotate-icon="addButton"
      upper-case
      emit-message="handle-action-button"
      v-on="$listeners"
    >
    </base-button>
  </div>
</template>

<script>
import BaseButton from './base-button.vue';

import CatalogPage from '@/classes/catalog-page';

export default {
  components: { BaseButton },
  props: {
    addonStatus: {
      type: String,
      default: '',
    },
    catalogPage: {
      type: Object,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    actionText() {
      if (this.addonStatus === CatalogPage.CATALOG_PAGE_STATUSES.INACTIVE) {
        return this.catalogPage?.enableButtonText || 'Add';
      }
      return 'Open';
    },
    addButton() {
      return this.addonStatus === CatalogPage.CATALOG_PAGE_STATUSES.INACTIVE;
    },
    enableButtonPrefix() {
      return this.catalogPage?.enableButtonPrefix || 'Try Free';
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-action-button-component {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  span {
    font-size: rem-calc(13);
  }
}
</style>
